"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var MAJORS = 'Majors ';
var MAJOR = 'Major ';
var getMajorTitle = function getMajorTitle(student) {
  switch (student.specialization) {
    case '6':
      return MAJOR;
    case '5':
      return MAJOR;
    case '4':
      return MAJORS;
    case '3':
      return MAJORS;
    case '2':
      return MAJORS;
    case '1':
      return MAJOR;
    default:
      return '';
  }
};
var _default = getMajorTitle;
exports.default = _default;